import { Pipe, PipeTransform } from '@angular/core';
  

@Pipe({name: 'distancePipe'})
export class DistancePipe implements PipeTransform {
  transform(distance: string): string {
  
    distance = (parseInt(distance)/1609.34).toFixed(1).toString();
  
    return distance;
  
  }
}
